import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import Resource from "../resource";
import { PageComponentResource } from "./page-component-resource";

@JsonObject()
export class PortalColumnResource extends Resource {
    @JsonProperty("width")
    width: number;

    @JsonProperty("components")
    @JsonElementType(PageComponentResource)
    components: Array<PageComponentResource> = [];
}
